export default __webpack_public_path__ + "static/media/villa_mercedes.825cc025.jpg";